import React, { useState } from "react";
import { PencilIcon } from "@heroicons/react/24/solid";
import axiosInstance from "../../utils/axiosInstance";
import HospitalImagePopup from "./HospitalImagePopup"; // Import the correct popup component

const HospitalTable = ({ hospitals, onEdit }) => {
  const [showImagePopup, setShowImagePopup] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);

  // Function to open image popup
  const openImagePopup = (image) => {
    setImageUrl(image);
    setShowImagePopup(true);
  };

  // Function to close image popup
  const closeImagePopup = () => {
    console.log("Closing popup"); // Debugging log
    setShowImagePopup(false);
    setImageUrl(null);
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse rounded-lg shadow-md overflow-hidden">
        <thead className="bg-gray-200 text-gray-700">
          <tr>
            <th className="p-3 text-left">Logo</th>
            <th className="p-3 text-left">Name</th>
            <th className="p-3 text-left">Phone</th>
            <th className="p-3 text-left">Email</th>
            <th className="p-3 text-left">Location</th>
            <th className="p-3 text-left">Description</th>
            <th className="p-3 text-left">Actions</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-300">
          {hospitals.length > 0 ? (
            hospitals.map((hospital) => (
              <tr key={hospital.id} className="hover:bg-gray-100 transition">
                <td className="p-3">
                  {hospital.image ? (
                    <img
                      src={
                        hospital.image.startsWith("http")
                          ? hospital.image
                          : `${process.env.REACT_APP_BASE_URL}${hospital.image}`
                      }
                      alt={`${hospital.name} Logo`}
                      className="w-14 h-14 object-cover rounded-md border cursor-pointer"
                      onClick={() => openImagePopup(hospital.image)} // Open popup on click
                    />
                  ) : (
                    <span className="text-gray-500">No Logo</span>
                  )}
                </td>
                <td className="p-3">
                  <div className="font-medium text-gray-800">
                    {hospital.name}
                  </div>
                  {hospital.website && (
                    <a
                      href={hospital.website}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-xs text-blue-600 hover:underline"
                    >
                      Visit Website
                    </a>
                  )}
                </td>
                <td className="p-3 text-gray-700">
                  {hospital.phoneNumber || (
                    <span className="text-gray-400">-</span>
                  )}
                </td>
                <td className="p-3 text-gray-700">
                  {hospital.email ? (
                    <a
                      href={`mailto:${hospital.email}`}
                      className="text-blue-600 hover:underline"
                    >
                      {hospital.email}
                    </a>
                  ) : (
                    <span className="text-gray-400">-</span>
                  )}
                </td>
                <td className="p-3 text-gray-700">
                  <div className="text-sm">
                    {hospital.city && hospital.state ? (
                      <>
                        <div>
                          {hospital.city}, {hospital.state}
                        </div>
                        {hospital.pincode && (
                          <div className="text-xs text-gray-500">
                            {hospital.pincode}
                          </div>
                        )}
                      </>
                    ) : (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </td>
                <td className="p-3 text-gray-600 truncate max-w-xs">
                  {hospital.description}
                </td>
                <td className="px-6 py-4">
                  <button
                    onClick={() => onEdit(hospital)}
                    className="bg-blue-600 text-white p-2 rounded-md hover:bg-blue-700 transition"
                    aria-label="Edit Hospital"
                  >
                    <PencilIcon className="w-5 h-5" />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="text-center p-5 text-gray-500">
                No hospitals found.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Image Popup */}
      {showImagePopup && (
        <HospitalImagePopup image={imageUrl} onClose={closeImagePopup} />
      )}
    </div>
  );
};

export default HospitalTable;
